import { render, staticRenderFns } from "./MarketCategories.vue?vue&type=template&id=05189604&"
import script from "./MarketCategories.vue?vue&type=script&lang=js&"
export * from "./MarketCategories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports